<div [ngClass]="fuseConfig.layout.navbar.secondaryBackground" class="navbar-header">
  <div (touchend)="touchUnfoldTemporarily(true)" class="logo">
    <mat-icon class="logo-icon" data-testid="logo-icon" svgIcon="svg_logo_prothesis"></mat-icon>
    <mat-icon class="logo-text" svgIcon="svg_logo_prothesis_text"></mat-icon>
  </div>

  <button
    (click)="toggleSidebarFolded()"
    (touchend)="touchUnfoldTemporarily(false)"
    class="toggle-sidebar-folded fx-hide_lt-lg"
    data-testid="toggle-sidebar-button"
    mat-icon-button
  >
    <mat-icon>menu</mat-icon>
  </button>

  <button (click)="toggleSidebarOpened()" class="toggle-sidebar-opened fx-hide_gt-md" mat-icon-button>
    <mat-icon class="s-16">arrow_back_ios</mat-icon>
  </button>
</div>

<div (touchend)="touchUnfoldTemporarily(true)" [ngClass]="fuseConfig.layout.navbar.primaryBackground" class="navbar-content">
  <app-navigation layout="vertical"></app-navigation>
</div>
